//CRN_20260508 - Riskline TripReady (Lite + Pro) PULL API
//             - Endpoint: POST https://api.riskline.com/ext/v1/trip-ready (proxied via SureSim backend)
//             - Vendor uses JSON:API envelopes; backend wraps/unwraps so the FE↔BE contract is flat camelCase

//#region Request

export interface TripReadyRequestDTO {
  departureDate: string;
  destination  : string;
  language?    : string;
  origin       : string;
  returnDate   : string;
}

export function TripReadyRequestDTO_EmptyObject(): TripReadyRequestDTO {
  return {
    departureDate: '',
    destination  : '',
    language     : 'en',
    origin       : '',
    returnDate   : ''
  };
}

//#endregion

//#region Response - JSON:API envelope

export interface TripReadyRelationshipRefDTO {
  id  : string;
  type: string;
}

export interface TripReadyRelationshipsDTO {
  [key: string]: { data: TripReadyRelationshipRefDTO | TripReadyRelationshipRefDTO[]; };
}

export interface TripReadyDataItemDTO {
  attributes    : { [key: string]: any; };
  id            : string;
  relationships?: TripReadyRelationshipsDTO;
  type          : string; //CRN_20260508 - destinations | advisories | alerts | summaries | emergency_number | female_travellers | lgbtq_travellers | visa_checks | vaccinations
}

export interface TripReadyIncludedItemDTO {
  attributes    : { [key: string]: any; };
  id            : string;
  relationships?: TripReadyRelationshipsDTO;
  type          : string; //CRN_20260508 - risk_levels | assessments | female_traveller_elements | visa_rules | etc.
}

export interface TripReadyJsonApiDTO {
  version: string;
}

export interface TripReadyResponseDTO {
  data    : TripReadyDataItemDTO[];
  included: TripReadyIncludedItemDTO[];
  jsonapi : TripReadyJsonApiDTO;
}

//#endregion
